<div class="contenedor">
  <div
    *ngFor="let indicator of indicators | async"
    class="indicators-container"
  >
    <div class="indicator-icon">
      <sit-icon class="d-flex"
        [icon]="indicator.icon"
        [sizeClass]="'icon-size-32'"
        alt="{{ indicator.tooltipTag }}"
        [tooltip]="indicator.tooltipTag"
        format="svg"
        colorClass="icon-fill-primary-1"
        hoverClass="icon-hover-secondary-2"
      />
      <!-- <sit-icon class="d-flex"
        [icon]="indicator.icon"
        [sizeClass]="'icon-size-32'"
        alt="{{ indicator.tooltipTag }}"
        [tooltip]="indicator.tooltipTag"
        colorClass="icon-fill-yellow"
      /> -->
    </div>
    <div class="indicator pl-05">
      <span>{{ indicator.data }}</span>
    </div>
  </div>
</div>
